import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Upload, Loader2, Camera as CameraIcon, Layers } from "lucide-react";

interface UploadCardsProps {
  uploading: boolean;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBatchOpen: () => void;
}

export function UploadCards({ uploading, onFileChange, onBatchOpen }: UploadCardsProps) {
  const navigate = useNavigate();

  return (
    <div className="grid md:grid-cols-3 gap-4">
      {/* Camera Upload */}
      <Card 
        className="p-6 hover:shadow-lg transition-shadow cursor-pointer" 
        onClick={() => !uploading && navigate('/receipts/new')}
      >
        <div className="flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-full bg-[#22c25c]/10 flex items-center justify-center mb-3">
            <CameraIcon className="w-7 h-7 text-[#22c25c]" />
          </div>
          <h3 className="font-semibold text-foreground mb-1">Multi-Photo Scanner</h3>
          <p className="text-xs text-muted-foreground">
            Capture up to 10 photos per receipt
          </p>
        </div>
      </Card>

      {/* File Upload */}
      <Card className="p-6 hover:shadow-lg transition-shadow">
        <label htmlFor="file-upload" className="cursor-pointer">
          <div className="flex flex-col items-center text-center">
            <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              {uploading ? (
                <Loader2 className="w-7 h-7 text-primary animate-spin" />
              ) : (
                <Upload className="w-7 h-7 text-primary" />
              )}
            </div>
            <h3 className="font-semibold text-foreground mb-1">File Upload</h3>
            <p className="text-xs text-muted-foreground">
              {uploading ? "Processing..." : "JPG, PNG, PDF (max 10MB)"}
            </p>
          </div>
        </label>
        <Input
          id="file-upload"
          type="file"
          accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
          onChange={onFileChange}
          className="hidden"
          disabled={uploading}
        />
      </Card>

      {/* Batch Upload */}
      <Card 
        className="p-6 hover:shadow-lg transition-shadow cursor-pointer" 
        onClick={() => !uploading && onBatchOpen()}
      >
        <div className="flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-3">
            <Layers className="w-7 h-7 text-primary" />
          </div>
          <h3 className="font-semibold text-foreground mb-1">Batch Upload</h3>
          <p className="text-xs text-muted-foreground">
            Upload up to 20 receipts at once
          </p>
        </div>
      </Card>
    </div>
  );
}
